import { useState, useEffect } from "react";
import { useCustomizationStore } from "features/ManageWebpage/modules/Customizations/store/useCustomizationStore";
import { useWebpageSectionChange } from "features/ManageWebpage/modules/Customizations/store/useWebpageSectionChange";
import { CUSTOMIZATION_SECTIONKEYS } from "features/ManageWebpage/modules/Customizations/common/utils/Customization.constants";

export const useTabIcon = () => {
  const sectionConfig = useCustomizationStore((state) => state.sectionConfig);
  const sectionValue = sectionConfig[CUSTOMIZATION_SECTIONKEYS.TAB_ICON]?.value;

  const [iconUrl, setIconUrl] = useState(sectionValue || null);
  const { handleSectionChange } = useWebpageSectionChange();

  useEffect(() => {
    setIconUrl(sectionValue || null);
  }, [sectionValue]);

  const handleUploadIcon = (url) => {
    setIconUrl(url);
    const payload = {
      feature_key: CUSTOMIZATION_SECTIONKEYS.TAB_ICON,
      feature_value: url,
    };
    handleSectionChange({ payload });
  };

  const handleRemoveIcon = () => {
    setIconUrl(null);
    const payload = {
      feature_key: CUSTOMIZATION_SECTIONKEYS.TAB_ICON,
      feature_value: null,
    };
    handleSectionChange({ payload });
  };

  return {
    iconUrl,
    handleUploadIcon,
    handleRemoveIcon,
  };
};
